import { render, staticRenderFns } from "./introDetail.vue?vue&type=template&id=e7fd752e&scoped=true&"
import script from "./introDetail.vue?vue&type=script&lang=js&"
export * from "./introDetail.vue?vue&type=script&lang=js&"
import style0 from "./introDetail.vue?vue&type=style&index=0&id=e7fd752e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fd752e",
  null
  
)

export default component.exports